import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CouponCode from '../coupon_code/CouponCode';
import Footer from '../footer/Footer';
import LineItems from '../../../checkout/components/order_summary/line_items/LineItems';
import FreeSamples from '../../../checkout/components/order_summary/free_samples/FreeSamples';
import Summary from '../../../checkout/components/order_summary/summary/Summary';
import QuadpayWidget from '../quadpay_widget/QuadpayWidget';
import styles from './CartContent.module.sass';
import UpSells from '../up_sells/UpSells';
import { giftCardOrderSelector, preorderOrderSelector } from '../../../checkout/selectors/order';

function CartContent(props) {
  const {
    lineItems, orderNumber, guestToken, orderTotal,
    applyCouponCodeRequest, couponCodeErrorText, couponCodeSuccessText,
    orderLoading, giftCardOrder, preorderOrder, freeSamplesTitle,
  } = props;

  return (
    <>
      <div className={styles.content}>
        <div className={styles['products-wrapper']}>
          <LineItems lineItems={lineItems} uneditable={false} />
          { !(giftCardOrder || preorderOrder) && (
            <FreeSamples freeSamplesTitle={freeSamplesTitle} />
          )}
          <UpSells />
        </div>
        <CouponCode
          applyCouponCodeRequest={applyCouponCodeRequest}
          couponCodeErrorText={couponCodeErrorText}
          couponCodeSuccessText={couponCodeSuccessText}
          guestToken={guestToken}
          orderNumber={orderNumber}
        />
        { !orderLoading && (
          <div className={styles.bottom}>
            <Summary showCongratulations estimatedTotal />
            <QuadpayWidget orderTotal={orderTotal} className={styles['quadpay-widget']} alignment="right" />
          </div>
        ) }
      </div>
      <Footer
        showOnlyCreditCard={
          lineItems.filter((lineItem) => lineItem.frequency > 0).length > 0
        }
      />
    </>
  );
}

CartContent.propTypes = {
  applyCouponCodeRequest: PropTypes.func.isRequired,
  couponCodeErrorText: PropTypes.string,
  couponCodeSuccessText: PropTypes.string,
  guestToken: PropTypes.string,
  lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  orderLoading: PropTypes.bool,
  orderNumber: PropTypes.string,
  orderTotal: PropTypes.number.isRequired,
  giftCardOrder: PropTypes.bool,
  preorderOrder: PropTypes.bool,
  freeSamplesTitle: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  giftCardOrder: giftCardOrderSelector(state),
  preorderOrder: preorderOrderSelector(state),
});

export default connect(mapStateToProps)(CartContent);
